import EmailSuccess from './EmailSuccess';

export default EmailSuccess;
